import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import AutoComplete from "../../../components/Comman/AutoComplete";
import { ButtonCompo } from "../../../components/Comman/Button";
import { LabelCompo } from "../../../components/Comman/Label";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import endpoint from "../../../config/endpoints";
import { getSalesExecutive } from "../../../Slice/salesExecutive.slice";
import { getStockStakeHolderType } from "../../../Slice/stockStakeHolderType.slice";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import SearchBar from "../../../components/Search";
import { serverMsg, noInternetMsg } from "../../../config/messageconstant";
import { titleColor, redColor } from "../../../config/ColorObj";
import { downloadF } from "../../PDF/PDFDownload";

class ReportingManagerList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stockHolderType: "",
      salesTeam: "",
      rowList: [],
      searchValue: "",
      formErrors: {},
      flag: "1",
    };
  }

  async componentDidMount() {
    const { getStockStakeHolderType, showLoador, showNotification } =
      this.props;

    showLoador({ loador: true });
    await getStockStakeHolderType({ userTypeIds: "3,4" }).then(
      ({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      }
    );
  }

  onAutocompleteChangeTypeWise = (name, newValue) => {
    const { showLoador, showNotification, getSalesExecutive } = this.props;

    if (name === "stockHolderType") {
      this.setState({
        stockHolderType: newValue,
      });

      if (newValue) {
        showLoador({ loador: true });
        getSalesExecutive({ stockStakeHolderId: newValue }).then(
          ({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
    }

    if (name === "salesTeam") {
      this.setState({
        salesTeam: newValue,
      });
    }
  };

  onSummaryHandlerTypeWise = () => {
    const { showLoador, showNotification } = this.props;
    const { salesTeam } = this.state;

    if (this.checkValidation()) {
      if (navigator.onLine) {
        showLoador({ loador: true });
        apiGet({
          url:
            endpoint.salesExecutive +
            "/below-sales-team-with-reporting-ids?salesTeamId=" +
            salesTeam +
            "&flag=1",
        }).then((data) => {
          showLoador({ loador: false });
          this.setState({
            rowList: data.data.data,
          });
        });
      } else {
        showNotification({ msg: noInternetMsg, severity: "error" });
      }
    }
  };

  checkValidation = () => {
    const { stockHolderType, salesTeam } = this.state;

    let formErrors = {};
    let formIsValid = true;

    if (stockHolderType === "" || stockHolderType === null) {
      formIsValid = false;
      formErrors["stockHolderTypeError"] = "Stock Holder Type Required";
    }

    if (salesTeam === "" || salesTeam === null) {
      formIsValid = false;
      formErrors["salesTeamError"] = "Sales Team Type Required";
    }

    this.setState({ formErrors });
    return formIsValid;
  };

  onSearchBox = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  getFilteredTableData = (tableData) => {
    const { searchValue } = this.state;
    return tableData.filter((currentRow) => {
      console.log(currentRow);
      let isValid = false;
      if (
        (currentRow["employeeCode"] &&
          currentRow["employeeCode"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["stockStakeHolderTypeName"] &&
          currentRow["stockStakeHolderTypeName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["reportingManagerName"] &&
          currentRow["reportingManagerName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["reportingManagerTypeName"] &&
          currentRow["reportingManagerTypeName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  generateExcel = () => {
    const { showLoador, showNotification } = this.props;
    const { fromDate, toDate, salesTeam, flag } = this.state;

    if (navigator.onLine) {
      showLoador({ loador: true });
      downloadF({
        isGet: true,
        url:
          endpoint.exportData +
          "/below-sales-team-report?salesTeamId=" +
          salesTeam +
          "&flag=" +
          flag,
        ext: "xlsx",
        openNewTab: true,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  //   generateExcel = (rowData) => {
  //     const { showLoador, showNotification } = this.props;
  //     const { dateForSalesTeamList } = this.state;

  //     console.log(rowData);

  //     // if (navigator.onLine) {
  //     //     showLoador({ loador: true });
  //     //     downloadF({
  //     //         url:
  //     //             endpoint.adminDashboard +
  //     //             "/get-excel-sales-teams?fromDate=" +
  //     //             dayjs(dateForSalesTeamList).format("DD-MM-YYYY") +
  //     //             "&toDate=" +
  //     //             dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
  //     //         ext: "xlsx",
  //     //         openNewTab: true,
  //     //     }).then((response) => {
  //     //         showLoador({ loador: false });
  //     //         if (!response) {
  //     //             this.props.showNotification({
  //     //                 msg: myConstClass.serverMsg,
  //     //                 severity: "error",
  //     //             });
  //     //         } else {
  //     //         }
  //     //     });
  //     // } else {
  //     //     showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
  //     // }
  //   };

  render() {
    const { stockStakeHolderTypeList, salesExecutiveList } = this.props;
    const { rowList, stockHolderType, salesTeam, formErrors } = this.state;

    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <>
            <Grid
              item
              sm={12}
              xs={12}
              md={12}
              lg={12}
              container
              justifyContent="space-between"
            >
              {/* Sales Team Type */}
              <Grid
                item
                sm={6}
                xs={8}
                md={6}
                lg={6}
                container
                justifyContent="space-evenly"
              >
                <Grid item xs={12} md={5} sm={5}>
                  <LabelCompo
                    className="text-black"
                    style={{ fontSize: 16, color: redColor }}
                    label={"*"}
                  />
                  <LabelCompo
                    className="text-black"
                    style={{ fontSize: 16, color: titleColor }}
                    label={"Sales Team Type :"}
                  />
                </Grid>

                <Grid item xs={12} md={7} sm={7}>
                  <AutoComplete
                    keyColName={"id"}
                    placeHolder="Select Sales Team Type"
                    value={stockHolderType}
                    name={"stockHolderType"}
                    options={stockStakeHolderTypeList?.stockStakeHolderType}
                    errorText={
                      formErrors["stockHolderTypeError"]
                        ? formErrors["stockHolderTypeError"]
                        : ""
                    }
                    isError={
                      formErrors["stockHolderTypeError"]
                        ? formErrors["stockHolderTypeError"]
                        : ""
                    }
                    onChange={this.onAutocompleteChangeTypeWise}
                  />
                </Grid>
              </Grid>

              {/* Sales Team */}
              <Grid
                item
                sm={6}
                xs={8}
                md={6}
                lg={6}
                container
                justifyContent="space-evenly"
              >
                <Grid item xs={12} md={5} sm={5}>
                  <LabelCompo
                    className="text-black"
                    style={{ fontSize: 16, color: redColor }}
                    label={"*"}
                  />
                  <LabelCompo
                    className="text-black"
                    style={{ fontSize: 16, color: titleColor }}
                    label={"Sales Team :"}
                  />
                </Grid>
                <Grid item xs={12} md={7} sm={7}>
                  <AutoComplete
                    keyColName={"id"}
                    placeHolder="Select Sales Team"
                    value={salesTeam}
                    name={"salesTeam"}
                    options={salesExecutiveList?.salesExecutive}
                    errorText={
                      formErrors["salesTeamError"]
                        ? formErrors["salesTeamError"]
                        : ""
                    }
                    isError={
                      formErrors["salesTeamError"]
                        ? formErrors["salesTeamError"]
                        : ""
                    }
                    onChange={this.onAutocompleteChangeTypeWise}
                  />
                </Grid>
              </Grid>

              {/* Buttons */}

              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                rowSpacing={2}
                columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                container
                justifyContent="right"
                marginTop={2}
              >
                <ButtonCompo
                  size="medium"
                  type="submit"
                  variant="contained"
                  name={"Search"}
                  onClick={() => this.onSummaryHandlerTypeWise()}
                />
              </Grid>
            </Grid>
          </>
          <br />

          <LandingScreenHeader
            screenTitle={""}
            showSearchBox={true}
            showTable={true}
            showFilter={false}
            showPdfDownload={false}
            showExcelDownload={true}
            generateExcel={this.generateExcel}
            onSearch={this.onSearchBox}
          />
          <TableContainer
            sx={{
              maxHeight: 400,
              overflow: "auto",
            }}
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead
                style={{
                  backgroundColor: "#fff",
                }}
              >
                <TableRow>
                  <TableCell
                    color="#000"
                    align="center"
                    sx={{ width: "1%", color: "#000" }}
                    canSearch="true"
                  >
                    Sr.No
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ width: "9%", color: "#000" }}
                    canSearch="true"
                  >
                    EMP Code
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ width: "9%", color: "#000" }}
                    canSearch="true"
                  >
                    Sales Team Name
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ width: "9%", color: "#000" }}
                    canSearch="true"
                  >
                    Sales Team Type Name
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ width: "9%", color: "#000" }}
                    canSearch="true"
                  >
                    Reporting Person Name
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ width: "7%", color: "#000" }}
                    canSearch="true"
                  >
                    Reporting Person Type Name
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.getFilteredTableData(rowList).map(
                  (salesTeamObject, index) => {
                    return (
                      <TableRow>
                        <TableCell align="center" canSearch="true">
                          {index + 1}
                        </TableCell>
                        <TableCell width="2%" canSearch="true" align="center">
                          {salesTeamObject.employeeCode !== null
                            ? salesTeamObject.employeeCode
                            : ""}
                        </TableCell>
                        <TableCell align="left" canSearch="true">
                          {salesTeamObject.name !== null
                            ? salesTeamObject.name
                            : ""}
                        </TableCell>
                        <TableCell align="left" canSearch="true">
                          {salesTeamObject.stockStakeHolderTypeName !== null
                            ? salesTeamObject.stockStakeHolderTypeName
                            : ""}
                        </TableCell>
                        <TableCell align="left" canSearch="true">
                          {salesTeamObject.reportingManagerName}
                        </TableCell>
                        <TableCell align="left" canSearch="true">
                          {salesTeamObject.reportingManagerTypeName}
                        </TableCell>
                      </TableRow>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  stockStakeHolderTypeList: state.stockStakeHolderType,
  salesExecutiveList: state.salesExecutive,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getStockStakeHolderType,
  getSalesExecutive,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportingManagerList);
